import axiosInstance from "../config/axios";

export interface AssetMasterAccessRecord {
  user_id: string;
  asset_master_access: boolean;
  read_access: boolean;
  write_access: boolean;
  delete_access: boolean;
  is_custodian?: boolean;
  is_approver?: boolean;
}

interface FixedAssetAccessResponse {
  data: AssetMasterAccessRecord[];
}

async function getUserAccess(userId: string): Promise<AssetMasterAccessRecord | null> {
  const response = await axiosInstance.get<FixedAssetAccessResponse>(
    "/fixedasset/getFixedAssetAccess",
    {
      params: { userId },
    }
  );

  const record = response.data?.data?.[0] || null;

  if (record) {
    record.is_custodian = record.is_custodian || false;
    record.is_approver = record.is_approver || false;
  }

  return record;
}

export const assetMasterService = {
  getUserAccess,
};

export default assetMasterService;
